import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./i18n/I18nContext";
import { CompareProvider } from "./context/CompareContext";
import AppLayout from "./components/layout/AppLayout";
import CompareTray from "./components/CompareTray";
import Home from "./pages/Home";
import Buy from "./pages/Buy";
import Rent from "./pages/Rent";
import Sell from "./pages/Sell";
import ListingDetail from "./pages/ListingDetail";
import DealerProfile from "./pages/DealerProfile";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import DealerDashboard from "./pages/DealerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Pricing from "./pages/Pricing";
import PaymentReturn from "./pages/PaymentReturn";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AdminBlog from "./pages/AdminBlog";
import AdminBlogEditor from "./pages/AdminBlogEditor";
import Compare from "./pages/Compare";

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <CompareProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors closeButton />
              <AppLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/buy" element={<Buy />} />
                  <Route path="/rent" element={<Rent />} />
                  <Route path="/sell" element={<Sell />} />
                  <Route path="/listing/:id" element={<ListingDetail />} />
                  <Route path="/dealer/:id" element={<DealerProfile />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/dealer-dashboard" element={<DealerDashboard />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/payment/return" element={<PaymentReturn />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/admin/blog" element={<AdminBlog />} />
                  <Route path="/admin/blog/new" element={<AdminBlogEditor />} />
                  <Route path="/admin/blog/edit/:id" element={<AdminBlogEditor />} />
                  <Route path="/compare" element={<Compare />} />
                </Routes>
              </AppLayout>
              <CompareTray />
            </BrowserRouter>
          </CompareProvider>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}
